import {initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
const firebaseConfig = {
apiKey: "AIzaSyBGUFR6C6fBzGFvcd0mjb5S_fviSO0Qbfo",
authDomain: "lenstalk.techassistantforblind.com",
projectId: "tech-assistant-for-blind-web",
storageBucket: "tech-assistant-for-blind-web.firebasestorage.app",
messagingSenderId: "46419414206",
appId: "1:46419414206:web:8beba7db8601b16eaca2ef",
measurementId: "G-M2B9SDLQ1K"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;